import { Box, Container, Paper, Typography } from '@mui/material';
import { PageHead } from '../../components/public/PageHead';

const sections = [
  { title: 'Commesse e clienti', description: 'Organizza i lavori per commessa, collega clienti e indirizzi. Gestisci stati, date e riferimenti in un unico posto.', items: ['Anagrafica commesse', 'Collegamento clienti', 'Stati e scadenze', 'Dettaglio e documenti'] },
  { title: 'Timeline operativa', description: 'Registra eventi, foto, note e audio direttamente dalla commessa. Una cronologia chiara di ciò che succede in cantiere.', items: ['Eventi temporali', 'Foto e allegati', 'Note e audio', 'Cronologia unificata'] },
  { title: 'Rapportini digitali', description: 'Rapportini compilabili da campo con attività, materiali, mezzi e firma. Generazione PDF e condivisione.', items: ['Rapportini e firma', 'Materiali e quantità', 'Mezzi utilizzati', 'Bolle collegate', 'Export PDF'] },
  { title: 'Materiali, DDT e mezzi', description: 'Catalogo materiali, gestione bolle/DDT e mapping fornitore–materiale. Tracciamento mezzi e consumi per commessa.', items: ['Catalogo materiali', 'Bolle e righe DDT', 'Mapping fornitore–materiale', 'Mezzi e costi (ore/km/viaggio)'] },
  { title: 'Documenti e condivisione', description: 'Documenti, preventivi e fatture collegati alle commesse. Condivisione e storico versioni.', items: ['Documenti per commessa', 'Preventivi e fatture', 'Condivisione e link', 'Storico versioni'] },
  { title: 'Presenze e organizzazione operativa', description: 'Presenze giornaliere, ore per commessa e report. Integrazione con costi e margini.', items: ['Presenze e ore', 'Report per commessa', 'Costi lavoro e materiali', 'Margini e overhead'] },
];

export function FeaturesPage() {
  return (
    <>
      <PageHead title="Funzionalità" description="Funzionalità Cantir: commesse, timeline, rapportini, materiali, DDT, documenti, presenze. Soluzione per la gestione cantieri." />
      <Box sx={{ py: 6, px: 2 }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>Funzionalità</Typography>
          <Typography color="text.secondary" align="center" sx={{ mb: 6 }}>Le aree del prodotto per gestire cantieri, squadra e documentazione.</Typography>
          {sections.map((section) => (
            <Paper key={section.title} variant="outlined" sx={{ p: 3, mb: 3 }}>
              <Typography variant="h5" fontWeight={600} gutterBottom>{section.title}</Typography>
              <Typography color="text.secondary" sx={{ mb: 2 }}>{section.description}</Typography>
              <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                {section.items.map((item) => (
                  <li key={item}><Typography component="span" variant="body2">{item}</Typography></li>
                ))}
              </Box>
            </Paper>
          ))}
        </Container>
      </Box>
    </>
  );
}
